import { Component, EventEmitter, OnInit, inject, model, signal } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TopbarComponent } from './topbar/topbar.component';
import { LocalstorageService } from '../shared/services/localstorage.service';
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NgClass } from '@angular/common';
import { User } from '../shared/models/user.model';
import { ProfileService } from '../profile/services/profile.service';
import { AccessModel } from '../core/models/access.model';
import { AccessService } from '../core/services/access.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    TopbarComponent,
    RouterModule,
    SidebarComponent,
    NgClass
],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent implements OnInit {
  private localstorageService = inject(LocalstorageService)
  private profileService = inject(ProfileService)
  private accessService = inject(AccessService)
  title = 'ServiTurno'
  username: string | undefined
  sidebarVisible = model<boolean>(true)
  disabled = {
    profile: {
      login: false,
      description: true,
      register: false,
    }
  }

  profile = signal<User | undefined>(undefined)
  access = signal<AccessModel | undefined>(undefined)

  ngOnInit(): void {
    this.sidebar(false)
    this.update()
  }
  setDisabled() {}

  setUsername() {
    this.username = this.localstorageService.get('username');
  }

  async update () {
    this.profile = this.profileService.getProfile()
    this.access = this.accessService.getAccess()
  }

  desactive(event: EventEmitter<any>) {
    // console.log('Desactivate Event emitted: ', event);
  }

  sidebar(event: boolean): void {
    this.sidebarVisible.update((value) => (value = event));
  }
}
